import { render, staticRenderFns } from "./PNInformation.vue?vue&type=template&id=48f717ea&scoped=true"
import script from "./PNInformation.vue?vue&type=script&lang=ts"
export * from "./PNInformation.vue?vue&type=script&lang=ts"
import style0 from "./PNInformation.vue?vue&type=style&index=0&id=48f717ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f717ea",
  null
  
)

export default component.exports